"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Car, TrainFront, ExternalLink } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocationAndDirections() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="standort-anreise" className="bg-background py-24 lg:py-32 overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className={`max-w-3xl mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground mb-6">Standort &amp; Anreise: der Weg zur Reiki &amp;&nbsp;Chakra Heilung!<br /></h1>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">Besuche mich im Herzen von Zürich, im schönen Kreis 6, zwischen Letten, Unterstrass und Wipkingen. Ein Ort, der speziell dafür geschaffen wurde, dir Abstand vom Alltag zu bieten.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          {}

          {}
          <div className={`flex flex-col justify-center h-full transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-8 mb-12">
              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-lg shrink-0">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Adresse
                  </h3>
                  <p className="text-muted-foreground leading-relaxed"><Link className="cursor-pointer !underline" href="https://www.google.com/maps/place/wandelherz+-+Reiki+Therapie+und+Energetisches+Heilen+Z%C3%BCrich/@47.3891213,8.5387774,17z/data=!3m1!4b1!4m6!3m5!1s0x4790807e2ff2522d:0x564f1d862e14fc25!8m2!3d47.3891213!4d8.5387774!16s%2Fg%2F1yh5tbjq1?entry=ttu&g_ep=EgoyMDI2MTAwNi4wIKXMDSoASAFQAw%3D%3D" newTab>Wandelherz<br />Schindlerstrasse 26<br />8006 Zürich</Link></p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-lg shrink-0">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Telefon
                  </h3>
                  <Link className="text-muted-foreground leading-relaxed underline cursor-pointer" href="tel:+41763717378" newTab><p className="text-muted-foreground leading-relaxed">+41 76 371 73 78</p></Link>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-lg shrink-0">
                  <Mail className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    E-Mail
                  </h3>
                  <Link className="text-muted-foreground leading-relaxed underline cursor-pointer" href="mailto:renata.wandelherz@gmail.com" newTab><p className="text-muted-foreground leading-relaxed">renata.wandelherz@gmail.com</p></Link>
                  <Link className="text-muted-foreground leading-relaxed hover:text-primary transition-colors block underline cursor-pointer" href="mailto:hallo@wandelherz.com" newTab></Link>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-muted p-3 rounded-lg shrink-0">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-2">
                    Öffnungszeiten
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Montag: 9:00–19:00 Uhr<br />
                    Dienstag: Geschlossen<br />
                    Mittwoch: Geschlossen<br />
                    Donnerstag: 9:00–19:00 Uhr<br />
                    Freitag: 9:00–19:00 Uhr<br />
                    Samstag: Geschlossen<br />
                    Sonntag: Geschlossen
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-border pt-10">
              
              
            </div>

            <div className="mt-10">
              
            </div>
          </div>

          <div className={`flex flex-col gap-6 transition-all duration-1000 delay-400 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_zurich.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_zurich.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_zurich.png-wvc-sizes" alt="Praxisräume in Zürich Oerlikon" className="w-full h-[280px] rounded-lg object-cover transition-transform duration-700 hover:scale-102" loading="lazy" src="https://wandelherz.ch/wp-content/uploads/2026/08/IMG_9722-scaled.jpg" src="https://wandelherz.ch/wp-content/uploads/2026/08/IMG_9724-2-scaled.jpg" />
            </div>
            <div className="overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_interior.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_interior.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/location_interior.webp-wvc-sizes" alt="Ruhige Behandlungsräume bei Wandelherz" className="w-full h-[280px] rounded-lg object-cover transition-transform duration-700 hover:scale-102" loading="lazy" src="https://wandelherz.ch/wp-content/uploads/2026/08/IMG_9722-scaled.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}